import { createFileRoute, redirect } from "@tanstack/react-router";

// Gole /kontrakty/raporty nie ma wlasnej strony — kieruj na pierwszy raport,
// zeby URL nie spadal do trasy /kontrakty/$id (Sentry FARMASTER-FRONTEND-3C).
export const Route = createFileRoute("/_auth/kontrakty/raporty/")({
	beforeLoad: () => {
		throw redirect({ to: "/kontrakty/raporty/podsumowanie" });
	},
});
